@if (relatedPosts() && relatedPosts().length > 0) {
  <h2 class="text-2xl font-bold mb-4">{{ header() }}</h2>

  <div class="flex flex-col gap-4">
    @for (post of relatedPosts(); track post.name) {
      <div class="border border-duck-blue-2 bg-duck-blue-9 rounded-lg p-4">
        <a [routerLink]="post.routerLink" class="text-xl text-duck-blue-2 font-bold mb-3">
          {{ post.name }}
        </a>
        <p class="mb-3">
          {{ post.description }}
        </p>
        <a [routerLink]="post.routerLink"
           class="text-base font-bold text-duck-blue-2">
          Läs mer om {{ post.name }} &nbsp;
          <app-ui-icon
            class="align-text-top"
            color="var(--duck-blue-2)"
            name="arrow_right"
            size="md"
          ></app-ui-icon>
        </a>
      </div>
    }
  </div>
}

